import React from 'react'

import Trackable from './Trackable'
import MetaTags from './MetaTags'
import HeroBase from '../components/HeroBase'
import TermsContent from '../components/TermsContent'

const title = 'Intento Terms of Service'
const description =
    'Access many AI vendors via a single integration with up to 23x better performance/price efficiency by using the right model for your specific case.'
const metatags = {
    title,
    description,
    og: {
        title,
        description,
        url: 'https://inten.to/terms',
    },
    twitter: {
        title,
        description,
    },
}

const Terms = () => (
    <Trackable page="terms">
        <MetaTags tags={metatags} />
        <HeroBase>
            <h1 className="hero__title h1">Terms of Service</h1>
        </HeroBase>
        <TermsContent />
    </Trackable>
)

export default Terms



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/containers/Terms.jsx